import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { DeviceSessionRefusals } from '@sharedlib/dtos/dto/accounts/device-sessions.dto';

/**
 * What a person reads when this browser already holds as many accounts as it may.
 *
 * THE NUMBER COMES FROM THE SERVER, never the word "five": the cap is a product decision published
 * as `limit` on `GET /api/account/sessions/device`, and a sentence with the figure written into it
 * goes quietly wrong the day the cap moves.
 */
export function deviceSessionLimitMessage(limit: number): string {
  return `You're signed in to ${limit} accounts on this device — sign out of one to add another.`;
}

/**
 * Whether this failure is the full-jar refusal, as opposed to any other 422.
 *
 * KEYED ON THE CODE AND NOT ON THE BARE STATUS, so every other 422 a sign-up ending can answer
 * keeps the message it ships today. The refusal travels as the `message` string alone — the
 * http-to-message bridge drops every sibling key — so there is nothing else to test.
 */
export function isDeviceSessionLimitRefusal(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse) || error.status !== HttpStatusCode.UnprocessableEntity) {
    return false;
  }
  const body: unknown = error.error;
  if (body === DeviceSessionRefusals.LIMIT_REACHED) {
    return true;
  }
  return (
    typeof body === 'object' &&
    body !== null &&
    Reflect.get(body, 'message') === DeviceSessionRefusals.LIMIT_REACHED
  );
}
